import { GlobalPeriodSelect } from '@components'

import { ReactElement, useCallback } from 'react'

import type { PeriodValue } from '../../../../types/periodValue'

interface ReviewEntriesMonthPeriodFilterProps {
  encodedPeriod: string
  onPeriodChange: (periodValue: PeriodValue) => void
}

export const ReviewEntriesMonthPeriodFilter = ({
  encodedPeriod,
  onPeriodChange,
}: ReviewEntriesMonthPeriodFilterProps): ReactElement => {
  const handlePeriodChange = useCallback(
    (periodValue?: PeriodValue) => {
      if (!periodValue) {
        return
      }

      onPeriodChange(periodValue)
    },
    [onPeriodChange],
  )

  return <GlobalPeriodSelect encodedPeriod={encodedPeriod} onChange={handlePeriodChange} placement="bottom-end" />
}
